import React from 'react';
import { Board } from '@/types';
import { SkeletonCards } from '@/components/organisms/Loading';
import { BoardCard } from '@/components/molecules/BoardCard';

interface BoardListProps {
  boards: Board[];
  loading?: boolean;
}

export const BoardList: React.FC<BoardListProps> = ({ boards, loading }) => {
  if (loading) {
    return <SkeletonCards count={6} />;
  }

  if (boards.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">No boards found</p>
      </div>
    );
  }

  return (
    <div className="board-list-component grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {boards.map((board) => (
        <BoardCard key={board.id} board={board} />
      ))}
    </div>
  );
};
